import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { motion } from 'framer-motion';
import Title2 from '../../../components/elements/Title2';
import { useParams } from 'react-router-dom';
import { profile, updateCoins } from '../../../slices/userSlice';
import { getTipById } from '../../../slices/tipsSlice';
import { getTipsIndexByChallengeId, purchase } from '../../../slices/tipsIndexesSlice';
import Swal from 'sweetalert2';
import adultboy from "../../../assets/images/adultBoy.png";

const TipsList = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { tipsIndexes, error, loading } = useSelector((state) => state.tipsIndexes);
  const { user } = useSelector((state) => state.user);
  const [hoveredItem, setHoveredItem] = useState(null);

  let result;
  useEffect(() => {
    dispatch(profile());
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(getTipsIndexByChallengeId({ userId: user._id, challengeId: id }));
  }, [dispatch, id, user, result]);

  const chargeTip = async (tipIdClicked) => {
    const tipData = {
      userId: user._id,
      tipId: tipIdClicked,
    };
    const result = await dispatch(getTipById(tipData));
    if (result.payload) {
      Swal.fire({
        title: `<h2 class="font-special font-bold">Pista</h2>`,
        html: `<img class="w-28 float-left" src="${adultboy}"><p class="font-special mb-5">${result.payload.content}</p><div id="swal-challenge-link"></div>`,
        showConfirmButton: false,
        background: "#f0f0f0",
      });
      dispatch(getTipsIndexByChallengeId({ userId: user._id, challengeId: id }));
    }
  };

  const buyTips = async (tipIdClicked) => {
    const tipData = {
      challengeId: id,
      userId: user._id,
      tipId: tipIdClicked,
    };
  
    try {
      result = await dispatch(purchase(tipData)).unwrap(); // Garante que o erro será lançado
      chargeTip(tipIdClicked);
    } catch (error) {
      Swal.fire({
        title: `<h2 class="font-special font-bold">Oops!</h2>`,
        html: `<p class="font-special mb-5">${error}</p>`,
        showConfirmButton: false,
        background: "#f0f0f0",
        icon: 'error',
      });
    }
  };

  return (
    <>
      <motion.div
        className="mb-3"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Title2 tit="Comprar pistas" model="def" />

        {loading ? (
          <p>Carregando pistas...</p>
        ) : tipsIndexes.tips && tipsIndexes.tips.length > 0 && (
          <ul className="">
            {tipsIndexes.tips.map((tip, index) => {
              // Define a classe e o comportamento para cada dica
              const liClass = tip.isPurchased
                ? "font-special bg-green-600 text-white p-1 font-semibold float-left ml-3 mt-1 rounded-full cursor-pointer"
                : !tipsIndexes.hasReachedDailyLimit
                ? "font-special bg-dour-suave text-white p-1 font-semibold float-left ml-3 mt-1 rounded-full cursor-pointer"
                : "font-special bg-dour-suave text-white p-1 font-semibold float-left ml-3 mt-1 rounded-full cursor-not-allowed";

              const handleClick = () => {
                if (tip.isPurchased) {
                  chargeTip(tip._id); // Se comprou, exibe a dica
                } else if (!tipsIndexes.hasReachedDailyLimit) {
                  buyTips(tip._id); // Se não atingiu o limite, permite comprar
                }
              };

              return (
                <motion.li
                  key={tip._id}
                  className={`${liClass} relative`}
                  onClick={tip.isPurchased || !tipsIndexes.hasReachedDailyLimit ? handleClick : null}
                  onMouseEnter={tipsIndexes.hasReachedDailyLimit ? () => setHoveredItem(index) : () => setHoveredItem(null)}
                  onMouseLeave={() => setHoveredItem(null)}
                >
                  <span className="tip-index">
                    Pista {index + 1} {/* Exibindo o índice +1 para o usuário */}
                  </span>
                  {hoveredItem === index && !tip.isPurchased && (
                    <motion.div
                      className="absolute font-special bottom-full mb-2 left-1/2 transform -translate-x-1/2 p-3 bg-white rounded-md shadow-lg text-sm text-preto-suave w-48 z-50"
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: 10 }}
                      transition={{ duration: 0.2 }}
                      
                    >
                      Você atingiu o limite de compras de pistas para hoje!
                    </motion.div>
                  )}
                </motion.li>
              );
            })}
          </ul>
        )}
      </motion.div>
    </>
  );
};

export default TipsList;
